import React, { useEffect } from "react";
import { Input } from "components/input";
import { Button } from "components/button";
import { useMutation } from "react-query";
import Axios from "axios";
import { Formik, Form } from "formik";
import { useSnackbarContext } from "components/snackbar";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import Spinner from "components/spinner";

const Personal = (props) => {
  const { t } = useTranslation();
  const tBase = "views.profile.components.personal";
  const tr = (key) => t(`${tBase}.${key}`);

  const { showSnackbar } = useSnackbarContext();
  const { userInfo, refetchUserInfo, onUpdateName } = props;

  const updateUser = useMutation(
    (values) =>
      Axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/v1/eserv-business/users/${userInfo.user_id}`,
        values
      ),
    {
      onSuccess: (variables) => {
        showSnackbar(tr("User info updated!"));
        refetchUserInfo(); 
        onUpdateName(variables.first_name, variables.last_name); 
      },
      onError: () => showSnackbar(tr("Error updating user info")),
    }
  );

  const initialValues = {
    first_name: userInfo?.first_name || "",
    last_name: userInfo?.last_name || "",
    email: userInfo?.email || "",
    phone: userInfo?.phone || "",
  };

  const validationSchema = Yup.object({
    first_name: Yup.string().required(tr("Required")),
    last_name: Yup.string().required(tr("Required")),
    email: Yup.string().email(tr("Invalid email")).required(tr("Required")),
    phone: Yup.string().required(tr("Required")),
  });

  return (
    <div className="flex-1 max-w-[500px] flex flex-col">
      {userInfo ? (
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values, { resetForm }) => {
            updateUser.mutate(values);
            resetForm(values);
          }}
        >
          {({
            touched,
            errors,
            dirty,
            isValid,
            values,
            handleBlur,
            handleChange,
          }) => {
            return (
              <Form>
                <Input
                  name="first_name"
                  label={tr("First Name")}
                  error={touched.first_name && errors.first_name}
                  value={values.first_name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <Input
                  name="last_name"
                  label={tr("Last Name")}
                  error={touched.last_name && errors.last_name}
                  value={values.last_name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <Input
                  name="email"
                  label={tr("Email")}
                  error={touched.email && errors.email}
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <Input
                  name="phone"
                  label={tr("Phone")}
                  error={touched.phone && errors.phone}
                  value={values.phone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <Button
                  primary
                  type="submit"
                  disabled={!dirty || !isValid}
                  className="mt-4"
                >
                  {tr("Submit")}
                </Button>
              </Form>
            );
          }}
        </Formik>
      ) : (
        <Spinner size={26} color="#ff5200" />
      )}
    </div>
  );
}

export default Personal;